import { api } from "@/api";

export type SystemConfiguration = {
  key: string;
  type: "String" | "Number" | "Boolean";
  stringValue: string;
  description: string;
};

export async function getSystemConfigurations(organizacionId?: string): Promise<SystemConfiguration[]> {
  const params = organizacionId ? { organizacionId } : {};
  const res = await api.get("configuration/params", { params });
  return res.data;
}